// v290 — Visuel fixe de la landing et de la page de connexion.
// Remplace le carrousel : une seule image, reprise telle quelle de la maquette
// validée (photo + cartes « L'IA au service de votre performance »,
// « Un métier qui avance » et signature manuscrite). Les proportions
// d'origine (686 × 1019) sont conservées : jamais d'étirement, jamais de
// recadrage des éléments graphiques.
import visual from "../assets/hero-v290/vehicleiq-pro-visuel.jpg";

export const HERO_VISUAL_RATIO = "686 / 1019";

export default function ViqHeroVisual({ className = "", eager = true }) {
  return (
    <figure className={`viq-hero-visual ${className}`.trim()}>
      <img
        src={visual}
        width="686"
        height="1019"
        alt="Professionnel VO utilisant VehicleIQ sur tablette devant un parc de véhicules : l'IA au service de votre performance, un métier qui avance, plus de temps pour ce qui compte."
        loading={eager ? "eager" : "lazy"}
        decoding="async"
      />
    </figure>
  );
}
